module.exports = __webpack_public_path__ + "static/img/holiday-results-1.7235240.png";